import {
  trackProductError,
  trackProductEvent,
  type ProductBaseProperties,
} from "./product";

export const EVENTS_FLOW = "events";

export type EventsEventName =
  | "event_create_clicked"
  | "event_filter_changed"
  | "event_export_clicked"
  | "event_create_submit_attempt"
  | "event_created"
  | "event_create_error"
  | "event_update_submit_attempt"
  | "event_updated"
  | "event_update_error"
  | "event_status_changed"
  | "event_status_change_error"
  | "event_participation_updated"
  | "event_participation_update_error"
  | "event_model_use_clicked"
  | "event_model_create_submit_attempt"
  | "event_model_created"
  | "event_model_create_error"
  | "event_form_chat_started"
  | "event_form_chat_field_collected"
  | "event_form_chat_completed"
  | "event_form_chat_submitted"
  | "event_form_chat_submit_error"
  | "ticketing_form_chat_started"
  | "ticketing_form_chat_field_collected"
  | "ticketing_form_chat_completed"
  | "ticketing_form_chat_submitted"
  | "ticketing_form_chat_submit_error"
  | "event_checkin_submit_attempt"
  | "event_checkin_success"
  | "event_checkin_error"
  | "attendance_checkin_success";

export const trackEventsEvent = (
  event: EventsEventName,
  baseProperties: ProductBaseProperties,
  eventProperties?: Record<string, unknown>,
): void => {
  trackProductEvent(event, baseProperties, eventProperties, EVENTS_FLOW);
};

export const trackEventsError = (
  event: EventsEventName,
  baseProperties: Omit<ProductBaseProperties, "success" | "errorCode">,
  error: unknown,
  eventProperties?: Record<string, unknown>,
): void => {
  trackProductError(
    event,
    baseProperties,
    error,
    eventProperties,
    EVENTS_FLOW,
  );
};
